import { render, staticRenderFns } from "./ResizingComponent.vue?vue&type=template&id=1d40bec7"
import script from "./ResizingComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ResizingComponent.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports